export default {"src":"/_next/static/media/ventureClosed.5bbd02e4.svg","height":33,"width":52,"blurWidth":0,"blurHeight":0};